
export default {
  name: "EstoqueCritico",
  props: {
    dados: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      loadingZerados: false,
      modalZeradosItens: [],
      zeradosPage: 1,
      zeradosPerPage: 10,
      zeradosTotal: 0,
      paginationFrom: 0,
      paginationTo: 0,
    };
  },
  computed: {
    modalId() {
      return `modal-estoque-zerado-${this._uid}`;
    },
    criticos() {
      return Number(this.dados?.criticos || 0);
    },
    zerados() {
      return Number(this.dados?.zerados || 0);
    },
    monitorados() {
      return Number(this.dados?.monitorados || 0);
    },
    itens() {
      return Array.isArray(this.dados?.itens) ? this.dados.itens : [];
    },
    zeradosItens() {
      if (Array.isArray(this.dados?.zerados_itens)) {
        return this.dados.zerados_itens;
      }

      return this.itens.filter((item) => Number(item?.quantidade || 0) <= 0);
    },
    listaResumo() {
      return this.zeradosItens.length
        ? this.zeradosItens.slice(0, 4)
        : this.itens;
    },
    destaqueValor() {
      return this.zerados || this.criticos;
    },
    destaqueLabel() {
      if (this.zerados) {
        return this.zerados === 1 ? "produto zerado" : "produtos zerados";
      }

      return this.criticos === 1 ? "produto no limite" : "produtos no limite";
    },
  },
  methods: {
    abrirModalZerados() {
      if (!this.zerados) return;

      this.$bvModal.show(this.modalId);
      this.fetchZerados(1);
    },
    async fetchZerados(page = this.zeradosPage) {
      try {
        this.loadingZerados = true;
        this.zeradosPage = Number(page) || 1;

        const { data } = await this.$http.post("/dashboard/estoque-zerado", {
          page: this.zeradosPage,
          per_page: this.zeradosPerPage,
        });

        this.modalZeradosItens = Array.isArray(data?.data) ? data.data : [];
        this.zeradosTotal = Number(data?.total || 0);
        this.zeradosPage = Number(data?.current_page || this.zeradosPage);
        this.zeradosPerPage = Number(data?.per_page || this.zeradosPerPage);
        this.paginationFrom = Number(data?.from || 0);
        this.paginationTo = Number(data?.to || 0);
      } finally {
        this.loadingZerados = false;
      }
    },
    abrirProduto(item) {
      if (!item?.id) return;

      this.$router.push({
        name: "produtosUpdate",
        params: { id_produto: item.id },
      });
    },
    formatNumber(value) {
      return new Intl.NumberFormat("pt-BR", {
        maximumFractionDigits: 2,
      }).format(Number(value) || 0);
    },
  },
};
